import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { estimatePeekSize, placeAtlasPeek } from '../../DocsArea/Atlas/utils/placeAtlasPeek';
import { renderIcon, DefaultCampaignIcon } from '../../SprintDetail/FlowchartView/utils/renderIcon';
import '../../DocsArea/Atlas/components/AtlasPeek.css';

const OpenOutIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

const CampaignsAtlasPeek = ({
  peek,
  folder,
  others,
  viewport,
  originX = 0,
  originY = 0,
  onOpen,
  onOpenInNewTab,
}) => {
  const cardRef = useRef(null);
  const [peekSize, setPeekSize] = useState(() => estimatePeekSize(peek));

  useLayoutEffect(() => {
    setPeekSize(estimatePeekSize(peek));
  }, [peek]);

  useLayoutEffect(() => {
    const el = cardRef.current;
    if (!el) return;
    const w = el.offsetWidth;
    const h = el.offsetHeight;
    if (Math.abs(w - peekSize.w) > 1 || Math.abs(h - peekSize.h) > 1) {
      setPeekSize({ w, h });
    }
  }, [peek, peekSize.w, peekSize.h, folder, viewport]);

  const placed = useMemo(() => {
    if (!folder || !viewport) {
      return { x: folder ? folder.x + folder.width + 12 : 0, y: folder?.y || 0 };
    }
    return placeAtlasPeek({ folder, others, peekSize, viewport });
  }, [folder, others, peekSize, viewport]);

  return (
    <div
      ref={cardRef}
      data-atlas-no-pan
      className="atlas__peek"
      style={{ left: placed.x - originX, top: placed.y - originY }}
      onClick={(e) => e.stopPropagation()}
      onContextMenu={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {peek.empty ? (
        <p className="atlas__peek-label">No nested campaigns</p>
      ) : (
        peek.groups.map((g) => (
          <div key={g.key} className="atlas__peek-group">
            <div className="atlas__peek-label">{g.label}</div>
            {g.shown.map((child) => (
              <button
                key={child.id}
                type="button"
                className="atlas__peek-chip"
                onClick={() => onOpen?.(child.id)}
                onMouseDown={(e) => {
                  if (e.button !== 1) return;
                  e.preventDefault();
                  e.stopPropagation();
                  onOpenInNewTab?.(child.id);
                }}
              >
                <span className="atlas__peek-chip-icon">
                  {renderIcon(child.icon, {
                    size: '14px',
                    fallback: <DefaultCampaignIcon size={14} />,
                    defaultColor: 'currentColor',
                  })}
                </span>
                <span className="atlas__peek-chip-title">{child.title || 'Untitled'}</span>
              </button>
            ))}
          </div>
        ))
      )}
      <button
        type="button"
        className="atlas__peek-browse"
        onClick={() => onOpen?.(peek.folderId)}
      >
        <OpenOutIcon />
        Open
      </button>
    </div>
  );
};

export default CampaignsAtlasPeek;
